import React from 'react';
import t from 'prop-types';
import "./Column.scss";

class Column extends React.Component {
  static propTypes = {
    className: t.string,
    align: t.string,
    sm: t.oneOfType([t.string, t.number]),
    mg: t.oneOfType([t.string, t.number]),
    lg: t.oneOfType([t.string, t.number]),
    xl: t.oneOfType([t.string, t.number]),
    children: t.oneOfType([t.element, t.array]),
  };

  render() {
    const {sm, md, lg, xl, align, className, ...props} = this.props;
    let _className = className ? `${className} col` : 'col';
    
    /* eslint-disable */
    sm ? _className += ` col-sm-${sm}` : _className;
    md ? _className += ` col-md-${md}` : _className;
    lg ? _className += ` col-lg-${lg}` : _className;
    xl ? _className += ` col-xl-${xl}` : _className;
    align === 'center' ? _className += ` align-center` : _className;
    align === 'right' ? _className += ` align-right` : _className;
    /* eslint-enable */
    
    return (
      <div {...props} className={_className}>
        {this.props.children}
      </div>
    );
  }
}

export default Column;
